var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.slimes.length)?_c('b-row',{staticClass:"ml-1 mr-1"},_vm._l((_vm.slimes),function(slime){return _c('slime-block',{key:'slime_' + slime.id,attrs:{"slime":slime}})}),1):_c('p',[_vm._v("Vous n'avez aucun slime pour le moment")])
}
var staticRenderFns = []

export { render, staticRenderFns }